var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStreamStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E8BF62;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.2,
    y: 84.2,
    width: 343.6,
    height: 343.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.2,
    y: 84.2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -106.0387 256)",
    width: 343.6,
    height: 343.6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.5,224c4.5,5.1,10.6,8.6,14.4,9.9c3.5,1.1,5.8,0.9,6.5-1.3c1-3.1-3.6-4.3-9.2-7.8 c-7-4.4-10.5-9.1-8.3-15.7c2.9-8.5,12-10.9,22-7.6c4.8,1.6,10.5,4.5,14.4,8.2l-3.5,10.8c-4.4-4.8-10.2-8.1-13.8-9.3 c-3.3-1.1-5.6-0.7-6.2,1.2c-1,3,3.5,4.1,9,7.6c7.1,4.4,10.8,8.9,8.6,15.9c-3,8.8-12.3,11.2-22.6,7.8c-4.8-1.6-10.8-4.6-14.8-8.6 L120.5,224z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.5,258.1c-2.3,0.6-6.3,0.4-9.8-0.7c-4.1-1.3-7.5-3.9-9.2-7.4c-1.4-3-1.7-6.8,0.4-13.2l4.8-14.9l-6.6-2.1 l3.4-10.4l6.6,2.1l3.4-10.5l13.2,1.9l-4.1,12.7l10.7,3.5l-3.4,10.4l-10.7-3.5l-4.4,13.6c-1.3,3.9-1.3,7.2,2.4,8.4 c2.1,0.7,4.6,0.6,6.5,0.3L184.5,258.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.7,221.5l12.2,4l-1.8,5.4l0.1,0.1c4.1-3,8.7-3.8,13.7-2.2c0.8,0.3,1.7,0.6,2.5,1.2l-3.8,11.8 c-0.9-0.6-2.1-1.1-3.2-1.5c-4.4-1.4-8.4-1.3-12.5,1.2l-8,24.5l-12.5-4.1L204.7,221.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.9,258.9c-0.4,6,3.4,10.1,9.1,12c4.5,1.5,10,1.5,15.2,0l-3.4,10.4c-4.7,1.2-11.2,0.4-16.6-1.3 c-13.3-4.3-20.2-15.8-16.1-28.4c4.2-12.9,16.9-18,28.1-14.4c9.9,3.2,17.2,12.9,12.8,26.4c-0.5,1.4-1.1,3.2-1.6,4.2L239.9,258.9z  M258.6,256.3c0.7-4.6-1.7-8.3-5.7-9.6c-3.9-1.3-8,0-10.6,4.3L258.6,256.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.8,292.4c-3.2,1-7.8,1.2-12.4-0.3c-3.5-1.1-6.5-3-8.5-5.7c-2.3-3-3.1-6.8-1.7-11c1.4-4.4,4.6-7.1,8.1-8.2 c3.8-1.1,8.1-0.5,12.3,0.8c2.4,0.8,4.7,1.8,6.7,3l0.5-1.6c0.6-2,0.5-3.7-0.2-4.8c-0.8-1.4-2.7-2.8-5.7-3.8 c-4.5-1.5-9.1-1.3-12.9-0.6l3.5-10.8c3.8-0.6,9.2-0.5,15.1,1.5c5.4,1.8,9.9,4.6,12.2,8.2c2.2,3.5,2.5,7.6,0.9,12.6l-4.5,13.7 c-0.6,1.9-0.3,3.4,1.4,4c0.7,0.2,1.5,0.3,2.2,0.2l-3,9.4c-1.6,0.3-4,0.1-6.4-0.7c-3.3-1.1-6.2-3-7.7-6L293.8,292.4z M296,278.3 c-1.2-0.8-2.9-1.6-4.2-2c-3.2-1-6.7-1.1-7.7,2c-0.9,2.6,1,4.8,3.9,5.7c2.1,0.7,4.4,0.6,6.2,0.2L296,278.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M374.2,295.5c1-3,1-4.6,0.3-6c-0.8-1.6-2.1-2.6-3.7-3.1c-2.9-0.9-6.3-0.4-9.1,0.8c-0.1,0.6-0.3,1.3-0.5,1.8 l-8.3,25.4l-12.5-4.1L348,287c0.9-2.7,1-4.5,0.3-6c-0.8-1.6-2.1-2.6-3.7-3.1c-2.9-0.9-6.3-0.3-9,0.7l-8.9,27.3l-12.5-4.1l13.2-40.4 l12.3,4l-1.2,3.6l0.1,0.1c4-1.6,8.7-2.2,13.7-0.6c4.4,1.4,8.8,4.8,9.9,9.6c5.6-2.4,11-2.8,16.1-1.1c4.5,1.5,7.5,4.2,9.1,7.4 c1.7,3.5,1.7,7.4-0.2,13.1l-8.3,25.4l-12.5-4.1L374.2,295.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamStar);
export default __webpack_public_path__ + "static/media/stream_star.076f142fd388319fa4b565a379285c7a.svg";
export { ForwardRef as ReactComponent };